import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { get_po_serial_number, updateProductSerialNumber } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../../Utility/UserContext';

const ProductSerialNo = () => {
    const location = useLocation();
    const { state } = location;
    const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
    const [search, setSearch] = useState();
    const [open, setOpen] = useState(false);
    const [serialNo, setSerialNo] = useState([]);
    const [selected, setSelected] = useState({});
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (state?.product_id) {
            fetchserialNo(state?.product_id);
        }
    }, [state])

    const fetchserialNo = async (PO_ID) => {
        try {
            const response = await get_po_serial_number(PO_ID,shopItem?.shop_id);
            console.log("response", response)

            if (response.data.data) {
                const Serialvalue = response?.data.data;
                setSerialNo(Serialvalue)
                console.log("Serial Number", Serialvalue);
            } else {
                toast.error('Serial Number No found.');
            }
        } catch (error) {
            console.error('Error fetching Serial Number:', error);
            toast.error('Error fetching Serial Number');
        }
    };

    const handleSearch = async (search) => {
        setSearch(search)
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSelected({ ...selected, [name]: value });
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleEdit = (serial) => {
        setSelected(serial);
        setOpen(true)
    }

    const handleUpdate = async (e) => {
        showLoader();
        const validationErrors = {};
        for (const key in selected) {
            if (
                key != "purchase_price" &&
                key != "selling_price"
            ) {
                continue;
            }
            if (!selected[key]) {
                validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
            }
        }

        if (Object.keys(validationErrors).length > 0) {
            hideLoader();
            setErrors(validationErrors);
            console.log(validationErrors);
            return;
        }

        try {
            await updateProductSerialNumber(selected?.id, selected);
            hideLoader();
            toast.success("Serial Number updated successfully");
            fetchserialNo(state?.product_id);
        } catch (error) {
            if (error.response && error.response.data) {
                toast.error(error.response.data.message || "Error updating serial number");
                hideLoader();
            } else {
                toast.error("Error updating serial number");
            }
        }
        handleCancel();
        hideLoader();
    };

    const handleCancel = () => {
        setOpen(false);
        setSelected({});
        setErrors({});
    };
    return (
        <div className="page-wrappers">
            <div className="page-content">
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 text-uppercase">Product Serial No : {state?.product_name}</h6>
                </div>
                <hr className='mt-1' />

                <div className="card">
                    <div className="card-body">
                        <div className="row align-items-center mb-3">
                            {/* Search Bar */}
                            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-0">
                                <div className="d-flex position-relative" style={{ width: "100%" }}>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Search..."
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                    <img
                                        src="/assets/images/icons/search.png"
                                        alt="Search Icon"
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            height: "18px",
                                            pointerEvents: "none",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                id="example"
                                className="table table-sm table-striped table-bordered align-baseline"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th style={{ width: "190px" }} >Serial No</th>
                                        <th>Purchase Price</th>
                                        <th>Sales Price</th>
                                        <th>Manufactured Date</th>
                                        <th>Expiry Date</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {serialNo.length > 0 ? (
                                        serialNo
                                            .filter(item => !search ? item : item.serial_number.toLowerCase().includes(search.toLowerCase()))
                                            .filter(item => item.status == "0")
                                            .map((serial, index) => (
                                                <tr key={serial.product_id}>
                                                    <td>
                                                        {index + 1}
                                                    </td>
                                                    <td style={{ whiteSpace: "normal", wordBreak: "breakWord" }}>
                                                        {serial.serial_number}</td>
                                                    <td>{serial?.purchase_price}</td>
                                                    <td>{serial?.selling_price}</td>
                                                    <td>{serial?.manufactured_date}</td>
                                                    <td>{serial?.expiry_date}</td>
                                                    <td>
                                                        <>
                                                            <img
                                                                src="/assets/images/icons/edit.png"
                                                                onClick={() => {
                                                                    handleEdit(serial)
                                                                }}
                                                                height={"16px"}
                                                            />
                                                        </>
                                                    </td>
                                                </tr>
                                            ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                No serial numbers found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Edit Modal */}
                {open && <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{selected?.serial_number}</h5>
                                <button type="button" className="btn-close" aria-label="Close" onClick={handleCancel}></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group mb-3">
                                        <label>Purchase Price</label>
                                        <input
                                            type="text"
                                            name="purchase_price"
                                            value={selected?.purchase_price}
                                            onChange={handleChange}
                                            className="form-control" />
                                        {errors.purchase_price &&
                                            <small className="text-danger">{errors.purchase_price}</small>}

                                    </div>
                                    <div className="form-group mb-3">
                                        <label>Sales Price</label>
                                        <input
                                            type="text"
                                            name="selling_price"
                                            value={selected?.selling_price}
                                            onChange={handleChange}
                                            className="form-control" />
                                        {errors.selling_price &&
                                            <small className="text-danger">{errors.selling_price}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label>Manufactured Date</label>
                                        <input
                                            type="date"
                                            name="manufactured_date"
                                            value={selected?.manufactured_date}
                                            onChange={handleChange}
                                            className="form-control" />
                                        {errors.manufactured_date &&
                                            <small className="text-danger">{errors.manufactured_date}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label>Expiry Date</label>
                                        <input
                                            type="date"
                                            name="expiry_date"
                                            value={selected?.expiry_date}
                                            onChange={handleChange}
                                            className="form-control" />
                                        {errors.expiry_date &&
                                            <small className="text-danger">{errors.expiry_date}</small>}
                                    </div>
                                    <div className="btn btn-success float-end" onClick={() => handleUpdate()}>Update</div>
                                    <button type="button" className="btn btn-secondary float-end me-2" onClick={handleCancel}>Cancel</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default ProductSerialNo
